import styled, { css } from "styled-components";
import { designTokens } from "../ui/foundation/DesignTokens";

export const GridLayout = styled.div`
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  display: grid;
  /* "incident" es su propia fila para que el aviso de caída de proveedor no
     comparta celda con "alert" (la de suscripción): dos elementos en un mismo
     grid-area se solapan. Al ser auto, la fila mide 0 mientras no haya aviso. */
  grid-template-rows: 70px auto auto 1fr;
  grid-template-columns: 100%;
  grid-template-areas:
  "nav"
  "incident"
  "alert"
  "main";

`;

export const Header = styled.header`
  grid-area: header;
`;

export const Main = styled.main`
  max-height: 100%;
  grid-area: main;
  overflow: hidden; /* Let child components handle their own scrolling */
  display: grid;
  box-shadow: -12px 0 24px -5px rgba(132, 146, 166, 0.16),
    12px 0 24px -5px rgba(132, 146, 166, 0.16);
  z-index: 1;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
  grid-template-areas: "page";
`;


export const SectionPage = styled.section`
  grid-area: page;
  max-height: 100%;
  max-width: 100%;
  background-color: ${designTokens.colors.gray[100]};
  display: grid;
  grid-template-rows: 9% 91%;
  grid-template-columns: 100%;
  grid-template-areas:
    "title"
    "content";
  ${(props) =>
    props.isChat &&
    css`
      background-color: white;
      grid-template-rows: 100%;
      grid-template-columns: 100%;
      grid-template-areas: "content";
    `}
`;

export const Title = styled.section`
  grid-area: title;
  display: flex;
  align-items: center;
  padding-left: ${designTokens.spacing.xl};
  padding-top: ${designTokens.spacing.xl};
  font-size: ${designTokens.fontSizes['3xl']};
  font-family: ${designTokens.fonts.heading};
  font-weight: 700;
`;

export const PageContainer = styled.section`
  ${(props) =>
    props.hideTitle
      ? css`
          grid-area: title / content;
          grid-row: 1 / 3;
          display: flex;
          flex-direction: column;
        `
      : css`
          grid-area: content;
        `}
  width: 100%;
  height: 100%;
  overflow-y: ${(props) => {
    if (props.isPageChat) return "hidden";
    if (props.hideTitle) return "hidden"; // Settings views handle their own scrolling via DrawerContent
    return "scroll";
  }};
  padding: ${(props) => {
    if (props.isChat) return "0";
    if (props.hideTitle) return "0"; // Settings views handle their own padding
    return "0 1.5rem 2rem";
  }};
`;
